import Team from "./Team";
import Member from "./Member";

export default {
  Team,
  Member
};
